import { z } from 'zod';
import { ROLES } from '../permissions.js';

/** Full matrix payload for the admin RBAC editor. */
export interface RbacMatrix {
  roles: Array<{ key: string; label: string; audience: string }>;
  permissions: Array<{ key: string; group: string; description: string }>;
  /** Hardcoded default permission keys per role (super_admin omitted — it gets all). */
  defaults: Record<string, string[]>;
  /** Current DB overrides. */
  overrides: Array<{ role: string; permissionKey: string; effect: 'grant' | 'revoke' }>;
  /** Resolved effective permission keys per role (defaults + overrides). */
  effective: Record<string, string[]>;
}

// effect 'default' clears any override, reverting to the hardcoded default.
export const updateOverrideSchema = z.object({
  role: z.enum(ROLES),
  permissionKey: z.string().min(1),
  effect: z.enum(['grant', 'revoke', 'default']),
});
export type UpdateOverrideRequest = z.infer<typeof updateOverrideSchema>;
